import { BaseMessage } from "./baseMessage";

export abstract class AbstractAccountMessage extends BaseMessage {
}